import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class CommodityReferenceService extends BaseReferenceService {
  constructor() {
    super('CommodityReference');
  }
}
